import React, { useContext, useState, useEffect, useCallback } from 'react'
import 'materialize-css'
import { Row, Col, Card, Button, Pagination, Icon } from 'react-materialize'

import { LoadingSmall } from '../loadingSmall';
import { LoadingFull } from '../loadingFull';

import { GlobalContext } from '../../context/GlobalState';

import { useTokenCittadino } from "../hooks/useTokenCittadino"

import { CardFiltriEnte } from '../CardFiltriEnte'


export const GestioneEnteRiscossioni = ({dettaglio, redirect}) => {
    const debug = process.env.REACT_APP_DEBUG === "true"
    const { token } = useTokenCittadino()
    const { datiEnte, cittadino } = useContext(GlobalContext);
    const [ riscossioni, setRiscossioni ] = useState(null);
    const [ riscossione, setRiscossione ] = useState(null);
    const [ filter, setFilter ] = useState(null);
    const [ codiceEnte, setCodiceEnte ] = useState(null)
    const [ loading, setLoading ] = useState(false)


    if (!codiceEnte) {
        setRiscossioni(null)
        setCodiceEnte(datiEnte?.idDominio)
    } else if (codiceEnte !== datiEnte?.idDominio) {
        setCodiceEnte(null)
    }


    // FILTRA I SERVIZI IN BASE AI PERMESSI
    const selectServizi = useCallback(
        () => {
            let abilitati = datiEnte?.entrate?.filter(entrata => entrata.abilitato)

            let tipiPendenza = {
                id: [],
                obj: []
            }

            if (cittadino.permessi[0].ENTE === "TUTTI") {
                tipiPendenza.obj = abilitati
                console.log({tipiPendenza})
                return tipiPendenza
            }

            let entiAmministrati = cittadino.permessi.filter(permesso => permesso.RUOLI[0].tipo === 'Amministratore').map(permesso => permesso.CF_PIVA_ENTE)
            if (entiAmministrati.includes(datiEnte.idDominio)) {
                tipiPendenza.obj = abilitati
                console.log({tipiPendenza})
                return tipiPendenza
            }

            let entiGestiti = cittadino.permessi.filter(permesso => permesso.RUOLI[0].tipo === 'GestoreServizi').map(permesso => permesso.CF_PIVA_ENTE)
            if (entiGestiti.includes(datiEnte.idDominio)) {
                let permesso = cittadino.permessi.filter(p => p.CF_PIVA_ENTE === datiEnte.idDominio)[0]
                let tipi = permesso.RUOLI.filter(r => r.tipo === 'GestoreServizi').map(item => item.servizi)
                
                if (tipi[0].length) {
                    tipiPendenza.id = tipi[0]
                    let obj = abilitati.filter(tipo => tipi[0].includes(tipo.tipoEntrata.idEntrata))
                    tipiPendenza.obj = obj
                    console.log({tipiPendenza, obj, datiEnte})
                    return tipiPendenza
                }

                console.log('FILTER E')
                tipiPendenza.obj = abilitati
                console.log({tipiPendenza})
                return tipiPendenza
            }

            return tipiPendenza

        }, 
        [datiEnte, cittadino]
    )


    const [selectPendenze, setSelectPendenze] = useState(selectServizi())


    useEffect(
        () => {
            let tipiPendenza = selectServizi()
            setSelectPendenze(tipiPendenza)
        }, 
        [setSelectPendenze, datiEnte, selectServizi]
    )
    // FILTRA I SERVIZI IN BASE AI PERMESSI


    const getRiscossioni = useCallback(
        async (filterData, page) => {
            setLoading(true)
            let response = await fetch(process.env.REACT_APP_SERVER_URL + 'ente/riscossioni/' + codiceEnte, {
                method: 'POST',
                body: JSON.stringify({token, filter: filterData, page, richiedente: cittadino.cf})
            })

            let res = await response.json()

            if (debug) console.log(res);
            if (res.valid) {
                if (riscossioni !== res.result) setRiscossioni(res.result)
                setLoading(false)
            } else {
                redirect("/")
            }
        },
        [token, codiceEnte, debug, redirect, cittadino, riscossioni, selectPendenze]
    )


    const getDettaglioRiscossioni = useCallback(
        async () => {
            let [iuv, iur, indice] = dettaglio.split('-')
            if (!riscossione || (riscossione?.iuv !== iuv && riscossione?.iur !== iur && riscossione?.indice !== indice)) {
                let response = await fetch(process.env.REACT_APP_SERVER_URL + 'ente/riscossioni/' + codiceEnte + '/' + iuv + '/' + iur + '/' + indice, {
                    method: 'POST',
                    body: JSON.stringify({token, richiedente: cittadino.cf})
                })

                let res = await response.json()

                if (debug) console.log(res); 
                if (res.valid) {
                    setRiscossione(res.result)
                } else {
                    redirect("/")
                }
            }
        },
        [token, codiceEnte, dettaglio, debug, redirect, cittadino, riscossione]
    )


    useEffect(() => {
        if (token) {
            if (dettaglio) {
                let [iuv, iur, indice] = dettaglio.split('-')
                if (riscossione?.iuv !== iuv && riscossione?.iur !== iur && riscossione?.indice !== indice) {
                    getDettaglioRiscossioni()
                }
            } else if (!dettaglio && !riscossioni) {
                getRiscossioni(filter, 1)
            }
        } else {
            redirect("/")
        }
    }, [token, redirect, dettaglio, getRiscossioni, getDettaglioRiscossioni, filter, datiEnte, cittadino, riscossione, riscossioni, codiceEnte])


    const visualizzaDettaglio = (iuv, iur, indice) => {
        let url = '/gestione_ente/riscossioni/' + iuv + '-' + iur + '-' + indice
        redirect(url)
    }


    const filterSaved = (filterData) => {
        if (debug) console.log('filter saved', filterData)
        setFilter(filterData)
        getRiscossioni(filterData, 1)
    }


    return (
        <>
            { loading ? <LoadingFull /> : null }
            {
                dettaglio ?
                <>
                    <Row>
                        <Col>
                            <Button onClick={() => redirect('/gestione_ente/riscossioni')}>indietro</Button>
                        </Col>
                        <Col>
                            <h4 style={{marginTop: 0}}>Dettaglio riscossione</h4>
                        </Col>
                    </Row>   
                    {
                        riscossione ?
                        <Card>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>ID voce pendenza:</b> {riscossione.idVocePendenza}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>Importo:</b> {riscossione.importo}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>IUR:</b> {riscossione.iur}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>IUV:</b> {riscossione.iuv}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>Data:</b> {riscossione.data}
                                </Col>
                            </Row>
                            <Row style={{marginBottom: '5px'}}>
                                <Col>
                                    <b>Stato:</b> {riscossione.stato}
                                </Col>
                            </Row>
                        </Card> :
                        <LoadingSmall />
                    }          
                </> :
                <>
                    <Row>
                        <Col s={12}>
                            <h4 style={{marginTop: 0}}>Riscossioni</h4>
                            <p>Elenco delle riscossioni ricevute</p>
                            <CardFiltriEnte tipo="riscossioni" onFilterSaved={filterSaved} idTipiPendenza={selectPendenze.id} selectTipiPendenza={selectPendenze.obj} />
                            <h5>Riscossioni trovate: { riscossioni ? riscossioni?.numRisultati : "0" }</h5>
                        </Col>
                    </Row>
                    {
                        riscossioni ?
                        <>
                            <Pagination
                                activePage={riscossioni.pagina}
                                items={riscossioni.numPagine}
                                leftBtn={<Icon>chevron_left</Icon>}
                                maxButtons={10}
                                rightBtn={<Icon>chevron_right</Icon>}
                                onSelect={(page) => getRiscossioni(filter, page)}
                            />
                            {riscossioni?.risultati?.map(
                                (item, i) => (<Card key={i}>
                                    <Row style={{marginBottom: '5px'}}>
                                        <Col>
                                            <b>riscossione (IUR):</b> {item.iur}
                                        </Col>
                                    </Row>
                                    <Row style={{marginBottom: '5px'}}>
                                        <Col>
                                            <b>importo:</b> {item.importo}
                                        </Col>
                                    </Row>
                                    <Row style={{marginBottom: '5px'}}>
                                        <Col>
                                            <b>pendenza:</b> {item.idVocePendenza}
                                        </Col>
                                    </Row>
                                    <Row style={{marginBottom: '5px'}}>
                                        <Col>
                                            <b>IUV:</b> {item.iuv}
                                        </Col>
                                    </Row>
                                    <Row style={{marginBottom: '5px'}}>
                                        <Col>
                                            <Button onClick={() => visualizzaDettaglio(item.iuv, item.iur, item.indice)}>DETTAGLI</Button>
                                        </Col>
                                    </Row>  
                                </Card>)
                            )} 
                        </> : 
                        <LoadingSmall />
                    }
                </>
            }
        </>
        
    );
}